<template>
    <div class="purchase-order-wrapper">
        <template v-if="!isAdmin">
            <PermissionDenied />
        </template>
        <template v-else>
            <vs-tabs v-model="activeTab">
                <!-- List Tab -->
                <vs-tab label="Purchase Order List" icon-pack="feather" icon="icon-list">
                    <div class="mt-6">
                        <PurchaseOrderList ref="poList" @create="createPo" @edit="editPo" :key="'po_list_view'" />
                    </div>
                </vs-tab>

                <!-- Form Tab -->
                <vs-tab v-if="(!selectedPo && canCreate) || (selectedPo && isAdmin)" :label="selectedPo ? (canEdit ? 'Edit Purchase Order' : 'View Purchase Order') : 'Add New Purchase Order'" icon-pack="feather" icon="icon-edit">
                    <div class="mt-6">
                        <PurchaseOrderForm :editData="selectedPo" @cancel="backToList" @success="onSuccess" />
                    </div>
                </vs-tab>
            </vs-tabs>
        </template>
    </div>
</template>

<script>
import PurchaseOrderList from './PurchaseOrderList.vue';
import PurchaseOrderForm from './PurchaseOrderForm.vue';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

export default {
    components: {
        PurchaseOrderList,
        PurchaseOrderForm
    },
    data() {
        return {
            activeTab: 0,
            selectedPo: null
        };
    },
    computed: {
        plusIcon: () => faPlus,
        isAdmin() {
            return this.$store.state.auth.userRole == 'admin' || this.hasAccess('read', 'purchase_order', 'any');
        },
        canCreate() {
            return this.$store.state.auth.userRole == 'admin' || this.hasAccess('create', 'purchase_order', 'all');
        },
        canEdit() {
            return this.$store.state.auth.userRole == 'admin' || this.hasAccess('edit', 'purchase_order', 'all');
        }
    },
    watch: {
        activeTab(newVal) {
            if (newVal === 0) {
                this.$nextTick(() => {
                    if (this.$refs.poList) this.$refs.poList.fetchItems();
                });
            }
        }
    },
    methods: {
        createPo() {
            this.selectedPo = null;
            this.activeTab = 1;
        },
        editPo(po) {
            this.selectedPo = po;
            this.activeTab = 1;
        },
        backToList() {
            this.selectedPo = null;
            this.activeTab = 0;
        },
        onSuccess() {
            this.backToList();
            this.$nextTick(() => {
                if (this.$refs.poList) {
                    this.$refs.poList.fetchItems();
                }
            });
        }
    }
}
</script>

<style scoped>
.purchase-order-wrapper {
    padding: 1rem;
}
</style>

